<template>
    <div class="ppv2-flex ppv2-flex-1 ppv2-items-center ppv2-gap-2 ppv2-rounded ppv2-px-3 ppv2-py-1 address-bar">
        <!-- Lock component / icon -->
        <Lock />
        <span :style="textStyles">
            {{ url }}
        </span>
    </div>
</template>

<script>
// Replace this with the correct path to your Lock component if needed
import { Lock } from 'lucide-vue'

export default {
    name: 'AddressBar',
    components: {
        Lock,
    },
    props: {
        url: {
            type: String,
            default: '',
        },
    },
    data() {
        return {
            textStyles: {
                color: 'rgba(255, 255, 255, 0.35)',
                fontSize: '0.78rem',
                fontFamily: 'ui-monospace, monospace',
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
            },
        }
    },
}
</script>

<style scoped>
.address-bar {
    background-color: #070a13 !important;
    border: 1px solid #1e293b;
    font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;
    font-size: 0.78rem !important;
    letter-spacing: 0.025em;
    min-width: 0;
}
</style>
